import React from "react";
//primereact
import { Button } from "primereact/button";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
//excel
import Excel from "../../assets/excel";
import * as XLSX from "xlsx";

const ExportTable = ({
  tableData,
  exportColumns,
  tabelaKey,
  globalFilterValue,
  onGlobalFilterChange,
  orientation = "portrait", // Define 'portrait' como padrão
}) => {
  const exportPdf = () => {
    import("jspdf").then((jsPDF) => {
      import("jspdf-autotable").then(() => {
        const doc = new jsPDF.default({
          orientation: orientation, // Usa a orientação fornecida (portrait ou landscape)
        });
        let startY = 10;

        doc.text(`Tabela: ${tabelaKey || "Download"}`, 10, startY);
        startY += 10;

        doc.autoTable({
          head: [exportColumns],
          body: tableData.map((row) => Object.values(row)),
          startY,
          columnStyles: {
            0: { cellWidth: "wrap" },
            1: { cellWidth: "wrap" },
            2: { cellWidth: "wrap" },
            3: { cellWidth: "wrap" },
            4: { cellWidth: "wrap" },
            5: { cellWidth: "wrap" },
            6: { cellWidth: "wrap" },
            7: { cellWidth: "wrap" },
            8: { cellWidth: "wrap" },
            9: { cellWidth: "wrap" },
            10: { cellWidth: "wrap" },
            11: { cellWidth: "wrap" },
            12: { cellWidth: "wrap" },
            13: { cellWidth: "wrap" },
            14: { cellWidth: "wrap" },
            15: { cellWidth: "wrap" },
            16: { cellWidth: "wrap" },
            17: { cellWidth: "wrap" },
            18: { cellWidth: "wrap" },
            19: { cellWidth: "wrap" },
            20: { cellWidth: "wrap" },
          },
          styles: {
            fontSize: 5, // Ajuste do tamanho da fonte
          },
          didDrawPage: (data) => {
            startY = data.cursor.y + 10;
          },
        });

        doc.save(`${tabelaKey || "Download"}.pdf`);
      });
    });
  };

  const exportExcel = () => {
    const table = tabelaKey || "Download";

    if (!Array.isArray(tableData)) {
      console.error("tableData is not an array");
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(tableData);
    // XLSX.utils.sheet_add_aoa(worksheet, [exportColumnsEx], { origin: "A1" });
    const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);

    // Criar um link temporário e clicar nele para iniciar o download
    const link = document.createElement("a");
    link.href = url;
    link.download = `${table}.xlsx`;
    link.click();

    // Liberar o URL do Blob após o download
    URL.revokeObjectURL(url);
  };

  return (
    <div className="row">
      <div className="d-flex justify-content-end pb-3 flex-grow-1">
        <div className="d-flex align-items-center justify-content-end gap-2">
          <div className="col-md-8">
            <IconField iconPosition="left">
              <InputIcon className="pi pi-search"> </InputIcon>
              <InputText
                placeholder="Pesquisar"
                className="w-100 rounded-4 ps-5"
                value={globalFilterValue}
                onChange={onGlobalFilterChange}
              />
            </IconField>
          </div>
          <Button
            type="button"
            className="rounded-5"
            severity="success"
            aria-label="Bookmark"
            data-pr-tooltip="XLS"
            icon={<Excel />}
            onClick={() => exportExcel(tabelaKey)}
          />
          <Button
            type="button"
            className="rounded-5"
            severity="secondary"
            icon="fa-solid fa-file-pdf"
            aria-label="Bookmark"
            data-pr-tooltip="PDF"
            onClick={() => exportPdf(tabelaKey)} // Passa o nome da tabela como parâmetro
          />
        </div>
      </div>
    </div>
  );
};

export default ExportTable;
